import { useState } from "react";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

export const RevertDefaultsButton = ({
  disabled,
  warning,
  onRevert,
}: {
  disabled: boolean;
  warning: string;
  onRevert: () => void;
}) => {
  const { t } = useTenantTranslation();
  const [open, setOpen] = useState(false);
  const close = () => {
    setOpen(false);
  };
  return (
    <>
      <Button
        sx={{ ml: "auto" }}
        size="small"
        variant="outlined"
        color="secondary"
        startIcon={<RestartAltIcon />}
        disabled={disabled}
        onClick={() => {
          setOpen(true);
        }}
      >
        {t("revertToScrapChefDefaults")}
      </Button>
      <Dialog open={open} onClose={close}>
        <DialogTitle>{t("revertToScrapChefDefaults")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{warning}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={close}>{t("cancel")}</Button>
          <Button
            variant="contained"
            color="warning"
            disabled={disabled}
            onClick={() => {
              onRevert();
              close();
            }}
          >
            {t("confirm")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
